export default "__VITE_ASSET__F_C8mreS__"